// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"966eabc9","455":"ba20698b","977":"f8e90cc2"}[chunkId] + ".chunk.js";
};